var error = {
  translation: {
    error: {
      coreNotFound: 'Nie znaleziono rdzenia',
      domainNotAllowed: 'Nie można zarejestrować się przy użyciu adresu email z tej domeny',
      emailAlreadyInUse: 'Email jest już używany',
      insufficientPermissions: 'Niewystarczające uprawnienia',
      invalidCurrentPassword: 'Błędne aktualne hasło',
      invalidPermissions: 'Wybierz przynajmniej jedno uprawnienie',
      invalidUsernameOrPassword: 'Błędna nazwa użytkownika lub hasło',
      localRegistrationDisabled: 'User local registration is disabled by the administrator',
      noInternetConnection: 'Brak połączenia z internetem',
      noOidcProfileFound: 'Nie znaleziono profilu OIDC',
      policyNotAccepted: 'Proszę zaakceptować Warunki świadczenia usług i Politykę prywatności',
      registrationDisabled: 'Rejestracja użytkowników została wyłączona przez administratora',
      serverConnectionFailed: 'Błąd połączenia z serwerem',
      ssoRegistrationDisabled: 'Rejestracja przez SSO użytkownika została wyłączona przez administratora',
      tooManyFailedAttempts: 'Zbyt wiele nieudanych prób - spróbuj ponownie później',
      unknownError: 'Nieznany błąd, spróbuj ponownie później',
      usernameAlreadyInUse: 'Nazwa użytkownika jest już używana',
      weakPassword: 'Użyj silniejszego hasła',
    },
  },
};

export { error as default };
